import React from "react";
import { motion } from "framer-motion";
/*import NohmiVideo from "../images/nohmihome.mp4";*/
import NohmiVideo from '../images/N3060.mp4'
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* Background Video */}
      <video
        src={NohmiVideo}
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover"
      />

      {/* Overlay */}
      <div className="absolute top-0 left-0 w-full h-full bg-green-900/70"></div>

      {/* Hero Content Wrapper (Text + Form side by side) */}
      <div className="relative z-10 flex flex-col md:flex-row items-center justify-between h-full px-6 md:px-12 xl:px-20 text-white">

        {/* Left Content */}
        <div className="flex-1 flex flex-col items-start justify-center">
          {/* Small Heading */}
          <motion.p
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1, duration: 1 }}
            className="uppercase tracking-widest text-lg md:text-2xl text-gray-200"
          >
            Trusted Fire Safety Solutions
          </motion.p>

          {/* Big Title */}
          <motion.h1
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 2, duration: 1 }}
            className="text-4xl md:text-6xl font-bold leading-tight mt-4"
          >
            Protecting Lives & Property <br /> with Nohmi Bosai India
          </motion.h1>

          {/* Divider */}
          <div className="w-64 h-[2px] bg-gray-300 mt-6 mb-6"></div>

          {/* Description */}
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 3, duration: 1 }}
            className="max-w-2xl text-md md:text-lg text-gray-200 text-justify"
          >
            Nohmi Bosai provides state of art fire protection systems and
            equipment trusted across industries worldwide. From smoke detection
            to fire suppression, we deliver solutions you can depend on.
          </motion.p>

          {/* CTA Button */}
          <Link to='/products'>
            <motion.button
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 4, duration: 0.8 }}
              className="mt-8 bg-green-700 hover:bg-green-800 text-white px-5 py-3 rounded-md font-semibold 
              flex items-center gap-2 text-base md:text-lg"
            >
              <span>Know More</span>
              <FaArrowRight className="text-lg md:text-xl" />
            </motion.button>
          </Link>
        </div>

        {/* Right Form 
        <div className="flex-1 bg-white/95 rounded-lg p-8 mt-10 md:mt-0 md:ml-10 shadow-xl text-gray-900 w-full max-w-sm h-[500px] flex items-center">
          <form className="w-full space-y-4">
            <h3 className="text-xl font-bold text-gray-800 mb-4 text-center">
              Fire Safety Product Inquiry
            </h3>

            {/* Name 
            <input
              type="text"
              placeholder="Full Name"
              className="w-full border-b p-2 outline-none text-sm"
            />

            {/* Company Name 
            <input
              type="text"
              placeholder="Company / Organization"
              className="w-full border-b p-2 outline-none text-sm"
            />

            {/* Phone 
            <input
              type="text"
              placeholder="Mobile No"
              className="w-full border-b p-2 outline-none text-sm"
            />

            {/* Email 
            <input
              type="email"
              placeholder="Email Address"
              className="w-full border-b p-2 outline-none text-sm"
            />

            {/* Product Type 
            <select className="w-full border-b p-2 outline-none text-gray-600 text-sm">
              <option>Select Product Type</option>
              <option>Fire Alarm System</option>
              <option>Smoke Detector</option>
              <option>Sprinkler System</option>
              <option>Fire Extinguisher</option>
              <option>Emergency Lighting</option>
              <option>Suppression System</option>
            </select>

            {/* City 
            <select className="w-full border-b p-2 outline-none text-gray-600 text-sm">
              <option>Select City</option>
              <option>Mumbai</option>
              <option>Bangalore</option>
              <option>Delhi</option>
              <option>Gurugram</option>
              <option>Chennai</option>
              <option>Kolkata</option>
            </select>

            {/* Submit 
            <button
              type="submit"
              className="w-full bg-green-700 text-white py-2 rounded hover:bg-green-800 transition text-sm"
            >
              Submit Request
            </button>
          </form>


        </div>*/}
      </div>
    </div>
  );
};

export default Home;
